module.exports = __webpack_public_path__ + "static/image/font/pc/bmhannaair-4@3x.jpg?d43ff97d";